import { BrowserRouter, Route, Routes } from "react-router-dom";
import DefaultView from "@chemaxon/terminus-client/ui/views/lead-generating-landing-page/LandingDefault";

const LeadGenLandingPageApp = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<DefaultView />} />
    </Routes>
  </BrowserRouter>
);

export default LeadGenLandingPageApp;
